import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import "./style.css";
import ScreenHeader from "@/components/ScreenHeader";

const OperationalAddons = ({ addons }) => {
  const { t } = useTranslation();

  return (
    <div className="oa-card bg-white">
      <ScreenHeader title={t("operational-addons")} className="bg-transparent mx-0 px-0" />

      <div className="oa-list">
        {addons?.map((addon) => (
          <Addon addon={addon} key={addon.id} />
        ))}
      </div>
    </div>
  );
};

export default OperationalAddons;

const Addon = ({ addon }) => {
  return (
    <div
      key={addon.id}
      className={`oa-item ${addon.isSelected ? "oa-item--selected" : ""}`}
    >
      <span
        className={`oa-checkbox ${addon.isSelected ? "oa-checkbox--checked" : ""}`}
      >
        {addon.isSelected && (
          <Icon icon="ph:check-fill" className="oa-check-icon" />
        )}
      </span>
      <div className="oa-info">
        <p className="oa-name">{addon.name}</p>
        <p className="oa-desc">{addon.description}</p>
      </div>
      <span className="oa-price">{addon.price?.toLocaleString()} $</span>
    </div>
  );
};
